export default "__VITE_ASSET__B63yV2oB__"